// Possible values for the login status context value
export enum LoginStatus {
	LOADING = "loading",
	IN = "in",
	OUT = "out",
	EMAIL_NOT_VERIFIED = "email_not_verified"
}
